export const omit = (key: string, { [key]: _, ...rest }: { [key: string]: any }) => rest
